module.exports = __webpack_public_path__ + "img/20f5.ec4d76a7.jpg";